import { ShieldAlert } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface WorkGroupPrivateAccessBannerProps {
  reason: string;
  onChangeReason: () => void;
}

export function WorkGroupPrivateAccessBanner({
  reason,
  onChangeReason,
}: WorkGroupPrivateAccessBannerProps) {
  return (
    <div className="flex flex-wrap items-start gap-3 rounded-md border border-border bg-muted/40 p-3">
      <ShieldAlert className="mt-0.5 h-4 w-4 shrink-0 text-muted-foreground" aria-hidden />
      <div className="min-w-0 flex-1 space-y-1">
        <p className="text-sm font-medium text-foreground">Administrator private access</p>
        <p className="text-sm text-muted-foreground">
          Active reason: <span className="text-foreground">{reason}</span>
        </p>
        <p className="text-xs text-muted-foreground">
          This reason is sent to the backend for auditing and is kept only for this browser session.
        </p>
      </div>
      <Button variant="outline" size="sm" className="shrink-0" onClick={onChangeReason}>
        Change reason
      </Button>
    </div>
  );
}
